import React from "react";
import {
	Avatar,
	Box,
	Container,
	Flex,
	Heading,
	Img,
	Link,
	ListItem,
	OrderedList,
	Text,
	Image,
} from "@chakra-ui/react";

const TheContextPotentialBlog: React.FC = () => (
	<>
		<Flex
			flexDirection="column"
			overflow="hidden"
			justify="center"
			height="100%"
			py={{ xs: "30px", sm: "40px", md: "60px", lg: "80px" }}
			h="100%"
			minH={{ xs: "400px", lg: "400px" }}
			maxH={{ xs: "400px", lg: "400px" }}
			pos="relative"
		>
			<Img
				pos="absolute"
				objectFit="cover"
				src="/webp/theContext-bg.webp"
				alt="members-hero"
				height="100%"
				width="100%"
			/>
			<Box
				bg="linear-gradient(78.35deg, rgba(13, 96, 81, 0.8) 18.38%, rgba(83, 92, 143, 0.8) 86.05%)"
				pos="absolute"
				height="100%"
				width="100%"
				opacity="0.7"
			/>
			<Container
				display="flex"
				as="section"
				maxW="container.xl"
				position="relative"
				zIndex="1"
				flexDir={{ xs: "column", md: "row" }}
				columnGap="24px"
				rowGap="30px"
				alignItems={{ xs: "flex-start", md: "flex-start" }}
				px={{ xs: "14px", sm: "28px", md: "45px", lg: "60px", xl: "inherit" }}
			>
				<Flex flexDir="column" rowGap="16px">
					<Heading
						color="white"
						fontSize={{ xs: "36px", sm: "42px", lg: "64px" }}
						fontWeight="800"
						lineHeight={{ xs: "35px", lg: "83px" }}
					>
						#TheContext
					</Heading>
					{/* <Heading
            color="white"
            fontSize={{ xs: '28px', sm: '34px' }}
            fontWeight="500"
            lineHeight="32px"
          >
            - By IVCA
          </Heading> */}
				</Flex>
				<Box
					w="1.5px"
					h={{ md: "200px", lg: "300px", xl: "230px" }}
					bgColor="white"
					display={{ xs: "none", md: "block" }}
				/>
				<Box
					w={{ xs: "70%", sm: "60%" }}
					h="1.5px"
					bgColor="white"
					display={{ xs: "block", md: "none" }}
				/>
				<Flex flexDir="column" rowGap="8px">
					<Heading
						as="h1"
						mb={{ xs: "10px", md: "20px" }}
						variant="reportCardTitle"
						fontSize={{ xs: "27px", sm: "29px", md: "32px", lg: "54px" }}
						color="white"
						lineHeight={{ xs: "36px", sm: "40px", md: "46px", lg: "70.2px" }}
					>
						Unleashing the Potential: Building from India for the World
					</Heading>
					<Text
						fontSize={{ xs: "18px", sm: "18px", md: "20px", lg: "22px" }}
						fontWeight="600"
						color="white"
						lineHeight="28px"
					>
						Rohan Dhamija
					</Text>
					<Text
						fontSize={{ xs: "18px", sm: "18px", md: "20px", lg: "22px" }}
						fontWeight="600"
						color="white"
						lineHeight="28px"
					>
						Ashwinder Sethi
					</Text>
					<Text
						fontSize={{ xs: "18px", sm: "18px", md: "20px", lg: "22px" }}
						fontWeight="600"
						color="white"
						lineHeight="28px"
					>
						Rahul Nawalkha
					</Text>
				</Flex>
			</Container>
		</Flex>
		<Container maxW="container.xl" pb="80px" pt="40px">
			<Flex
				flexDir={{ xs: "column-reverse", md: "row" }}
				px={{ xs: "8px", md: "0px" }}
			>
				<Flex
					w={{ xs: "100%", md: "27%" }}
					mt={{ xs: "32px", md: "0px" }}
					flexDir="column"
					rowGap="16px"
					mr={{ xs: "0px", md: "40px" }}
					ml={{ xs: "0px", sm: "10px" }}
					mb={{ xs: "16px", md: "8px" }}
				>
					<Heading
						fontSize="22px"
						lineHeight="22px"
						textAlign={{ xs: "center", sm: "left" }}
					>
						Follow the Authors
					</Heading>
					<Box
						w="100%"
						h="1.5px"
						bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
						my="8px"
					/>
					{[
						{
							name: "Rohan Dhamija",
							position:
								"Managing Partner, Director (Head - South Asia and Middle East), Analysys Mason",
							image:
								"https://static.levocdn.com/WGLBUT82/Rohan_Dhamija%20(Conf%20pic)-7166791776838220475.jpeg",
						},
						{
							name: "Ashwinder Sethi",
							position: "Partner, Analysys Mason",
							image:
								"https://static.levocdn.com/WGLBUT82/Ashwinder_Sethi%20(Conf%20pic)-7166791776840566450.jpeg",
						},
						{
							name: "Rahul Nawalkha",
							position: "Engagement Manager, Analysys Mason",
							image:
								"https://static.levocdn.com/WGLBUT82/Rahul-Nawalkha_1205x855-7166791776812356502.jpeg",
						},
					].map((item, index) => (
						<Flex
							key={index}
							flexDir={{ xs: "column", sm: "row", md: "column" }}
							columnGap="20px"
							rowGap="16px"
						>
							<Flex
								flexDir="column"
								alignItems={{ xs: "center", sm: "flex-start" }}
								rowGap="8px"
							>
								<Box boxSize="95px" borderRadius="50%" overflow="hidden">
									<Avatar
										name={item.name}
										w="100%"
										h="100%"
										src={item.image}
										objectFit="cover"
									/>
								</Box>
								<Flex flexDir="column" rowGap="4px">
									<Heading
										variant="blogQuestion"
										textAlign={{ xs: "center", sm: "left" }}
									>
										{item.name}
									</Heading>
									<Text
										variant="blogAnswer"
										textAlign={{ xs: "center", sm: "left" }}
										fontStyle="italic"
									>
										{item.position}
									</Text>
								</Flex>
							</Flex>
						</Flex>
					))}
				</Flex>

				<Box w={{ xs: "100%", md: "73%" }}>
					<Text variant="blogAnswer" mb="20px">
						Tech tools such as software as a service (SaaS) and AI are
						increasingly becoming a strategic must-have for businesses as a core
						tenet for success. Historically, the market for such tech tools was
						dominated by large foreign players. However, over the past few years
						several new and incumbent Indian players have entered and scaled up
						in the market, offering horizontal as well as tailored vertical
						solutions to not only Indian enterprises or consumers, but global
						markets as well. As a result, Indian tech players have been emerging
						as formidable competitors to their global peers.
					</Text>
					<Text variant="blogAnswer" pb="20px">
						The two key reasons why Indian tech players have been able to scale
						globally are:
					</Text>
					<OrderedList>
						<ListItem mb="4px">
							<Text variant="blogAnswer" pl={{ md: "12px" }}>
								<Text as="span" fontWeight="700">
									Favourable tech ecosystem:
								</Text>{" "}
								The conducive tech ecosystem in India, including the skilled
								workforce available, is enabling Indian players to deliver
								high-quality product and support solutions, and customized
								features and functionality to businesses of all sizes, and
								across geographies.
							</Text>
						</ListItem>
						<ListItem mb="4px">
							<Text variant="blogAnswer" pl={{ md: "12px" }}>
								<Text as="span" fontWeight="700">
									Competitive pricing:
								</Text>{" "}
								Indian players have been able to offer highly competitive
								pricing owing to their lower operating cost structures; this has
								led to accelerated scaling up of domestic players and improved
								unit economics compared to their global peers.
							</Text>
						</ListItem>
					</OrderedList>
					<Text variant="blogAnswer" pb="20px">
						However, even though the Indian tech ecosystem and players have seen
						rapid progress over the past few years, they have not been the flag
						bearers of innovation at a fundamental level. Let us take the case
						of AI, for instance. Indian AI players have so far developed
						solutions largely by relying on the foundational AI models/services
						provided by global players like Google, Meta and Amazon, among
						others (see Figure 1). However, the Indian AI ecosystem is evolving
						rapidly. Indian players are developing solutions based on their own
						foundational technologies as well, but there is still some way to go
					</Text>
					<Text variant="blogAnswer" fontStyle="italic">
						Figure 1: Key layers of the Al stack [Source: Analysys Mason, 2024]
					</Text>
					<Image
						src="https://static.levocdn.com/WGLBUT82/Screenshot%202024-02-23%20192514-7166792778227476443.png"
						alt="Key layers of the Al stack"
					/>
					<Text variant="blogAnswer" pt="20px" pb="20px">
						We believe that the Indian tech industry is at the cusp of a
						paradigm shift. While there is certainly a long journey ahead for
						them, the industry is well poised for sustained growth. Moreover,
						the Indian tech industry has also demonstrated its robustness over
						the past couple of years. As global tech players witnessed a huge
						drop-off in their valuations during 2022 and early 2023, their
						Indian counterparts remained markedly more resilient due to their
						ability to cater to a global customer base, their lower cost
						structures, and significant headroom for growth. Investors worldwide
						do realize this ‘once-in-a-lifetime’ opportunity.
					</Text>
					<Text variant="blogAnswer" pb="20px">
						At Analysys Mason, our engagements with both domestic and foreign
						investors who are considering this space has substantially increased
						as well in recent times. And as the nation continues to ramp up its
						capabilities in this domain, its future only looks brighter.
					</Text>
					<Text variant="blogAnswer" pb="20px">
						To read other Analysys Mason articles on the Indian Internet and
						Technology space,{" "}
						<Link
							href="https://www.analysysmason.com/press/"
							target="_blank"
							style={{ color: "blue", textDecoration: "underline" }}
						>
							click here.
						</Link>
					</Text>
				</Box>
			</Flex>
			<Box w="100%" h="1.5px" mt="16px" mb="8px" bgColor="gray.700" />
			<Text variant="blogAnswer" fontStyle="italic" p="12px 12px 0px">
				<Heading variant="blogQuestion" fontStyle="normal" as="span">
					#TheContext by IVCA{" "}
				</Heading>
				– features opinion makers from the alternate investing industry with
				strong focus on India as investment destination. Watch this space for
				viewpoints on investment themes, emerging trends, economic analysis and
				latest industry insights.
			</Text>
			<Heading
				variant="blogQuestion"
				lineHeight="30px"
				pt="16px"
				fontStyle="italic"
				p="12px 12px 0px"
			>
				Content in this section is curated by team IVCA. To share feedback,
				connect with &nbsp;
				<Link
					href="mailto:paromita.sinha@ivca.in"
					target="_blank"
					style={{ color: "blue", textDecoration: "underline" }}
				>
					paromita.sinha@ivca.in
				</Link>
			</Heading>
		</Container>
	</>
);

export default TheContextPotentialBlog;
